var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#CFB47A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.79297L10.293 13.5C10.2002 13.5928 10.1265 13.703 10.0763 13.8243C10.026 13.9457 10.0002 14.0757 10.0002 14.207C10.0002 14.3383 10.026 14.4683 10.0763 14.5896C10.1265 14.7109 10.2002 14.8211 10.293 14.914C10.3859 15.0068 10.4961 15.0805 10.6174 15.1307C10.7387 15.181 10.8687 15.2068 11 15.2068C11.1313 15.2068 11.2614 15.181 11.3827 15.1307C11.504 15.0805 11.6142 15.0068 11.707 14.914L14 12.621V20.207C14 20.4722 14.1054 20.7265 14.2929 20.9141C14.4805 21.1016 14.7348 21.207 15 21.207C15.2652 21.207 15.5196 21.1016 15.7071 20.9141C15.8947 20.7265 16 20.4722 16 20.207V12.621L18.293 14.914C18.3857 15.0072 18.4958 15.0811 18.6172 15.1316C18.7385 15.182 18.8686 15.208 19 15.208C19.1314 15.208 19.2616 15.182 19.3829 15.1316C19.5042 15.0811 19.6144 15.0072 19.707 14.914C19.8945 14.7264 19.9998 14.4721 19.9998 14.207C19.9998 13.9418 19.8945 13.6875 19.707 13.5L15 8.79297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.d8085810690f60413e56bcf87ffa7856.svg";
export { ForwardRef as ReactComponent };